import { AuthenticationEntity } from "@modules/auth/entities/auth.entity";
import { API_HEADER, API_URL } from "@modules/shared/enums/common-enum";
import { fetchWithAuth } from "@modules/shared/helpers/fetch-with-auth.helper";

export default class MediaService {
    private getHeaders() {
        const { ["Content-Type"]: _unuser, ...rest } = API_HEADER as Record<string, string>;
        return {
            ...rest,
        };
    }

    async uploadFile(
        data: FormData,
        auth: AuthenticationEntity | null,
        setAuth: (auth: AuthenticationEntity | null) => void,
        logout: () => void
    ) {
        try {
            const response = await fetchWithAuth(
                `${API_URL.MEDIA_URL}/upload`,
                {
                    method: "POST",
                    headers: this.getHeaders(),
                    body: data,
                },
                auth,
                setAuth,
                logout
            );

            return response;
        } catch (err) {
            console.error("Failed to upload: ", err);
            throw err;
        }
    }

    // General fetch list by type
    async getAllMediaByType(
        lang: string,
        { page, limit }: { page: number; limit: number },
        type: string,
        auth: AuthenticationEntity | null,
        setAuth: (auth: AuthenticationEntity | null) => void,
        logout: () => void,
    ) {
        try {
            const response = await fetchWithAuth(
                `${API_URL.MEDIA_URL}/app-media?page=${page}&limit=${limit}&type=${type}`,
                {
                    method: 'GET',
                    headers: {
                        ...this.getHeaders(),
                        "x-language": lang
                    }
                },
                auth,
                setAuth,
                logout
            );

            return response;
        } catch (error) {
            console.error(`Failed to fetch media (${type}): `, error);
            throw error;
        }
    }

    // General add media
    async addMedia(
        form: FormData,
        auth: AuthenticationEntity | null,
        setAuth: (auth: AuthenticationEntity | null) => void,
        logout: () => void
    ) {
        try {
            const response = await fetchWithAuth(
                `${API_URL.MEDIA_URL}/app-media`,
                {
                    method: 'POST',
                    headers: this.getHeaders(),
                    body: form
                },
                auth,
                setAuth,
                logout
            );

            return response;
        } catch (error) {
            console.error('Failed to add media: ', error);
            throw error;
        }
    }

    // Get media by content group (same)
    async getMediaByContentId(
        content_id: string,
        auth: AuthenticationEntity | null,
        setAuth: (auth: AuthenticationEntity | null) => void,
        logout: () => void
    ) {
        try {
            const response = await fetchWithAuth(
                `${API_URL.MEDIA_URL}/app-media/content-group?content_id=${content_id}`,
                {
                    method: 'GET',
                    headers: this.getHeaders(),
                },
                auth,
                setAuth,
                logout
            );

            return response.data;
        } catch (error) {
            console.error('Get media by content id failed: ', error);
            throw error;
        }
    }

    // Soft delete by content_id
    async deleteMediaByContentId(
        content_id: string,
        auth: AuthenticationEntity | null,
        setAuth: (auth: AuthenticationEntity | null) => void,
        logout: () => void
    ) {
        try {
            const response = await fetchWithAuth(
                `${API_URL.MEDIA_URL}/app-media/content-group/${content_id}`,
                {
                    method: 'DELETE',
                    headers: this.getHeaders(),
                },
                auth,
                setAuth,
                logout
            );

            return response;
        } catch (error) {
            console.error('Delete media by content id failed: ', error);
            throw error;
        }
    }

    // Update media by ID
    async updateMedia(
        id: string,
        formData: FormData,
        auth: AuthenticationEntity | null,
        setAuth: (auth: AuthenticationEntity | null) => void,
        logout: () => void
    ) {
        try {
            const response = await fetchWithAuth(
                `${API_URL.MEDIA_URL}/app-media/${id}`,
                {
                    method: 'PUT',
                    headers: this.getHeaders(),
                    body: formData
                },
                auth,
                setAuth,
                logout
            );

            return response;
        } catch (error) {
            console.error('Update media failed: ', error);
            throw error;
        }
    }

}

